<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>{{ message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="cancel()">取消</button>
  <button mat-raised-button color="primary" (click)="confirm()" autofocus>確認</button>
</mat-dialog-actions>
